(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-gradient-background"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('campaign-gradient-background')) {
    class CampaignGradientBackground extends HTMLElement {
      connectedCallback() {
        this.scopeItems = [];
        this.frame = null;
        this.main = this.closest('main') || document.querySelector('#MainContent') || document.body;
        this.scheduleUpdate = this.scheduleUpdate.bind(this);
        this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
        this.resizeObserver.observe(this.main);
        window.addEventListener('resize', this.scheduleUpdate, { passive: true });
        window.addEventListener('load', this.scheduleUpdate, { once: true });
        document.addEventListener('shopify:section:load', this.scheduleUpdate);
        document.addEventListener('shopify:section:reorder', this.scheduleUpdate);
        this.scheduleUpdate();
      }

      disconnectedCallback() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.resizeObserver?.disconnect();
        window.removeEventListener('resize', this.scheduleUpdate);
        window.removeEventListener('load', this.scheduleUpdate);
        document.removeEventListener('shopify:section:load', this.scheduleUpdate);
        document.removeEventListener('shopify:section:reorder', this.scheduleUpdate);
        this.clearScopeItems();
      }

      scheduleUpdate() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updateScope();
        });
      }

      clearScopeItems() {
        this.scopeItems.forEach((item) => item.classList.remove('campaign-gradient-scope-item'));
        this.scopeItems = [];
      }

      findEndTarget() {
        const endSectionName = (this.dataset.endSectionName || '').trim();
        if (!endSectionName) return null;
        return Array.from(this.main.querySelectorAll('[name]')).find(
          (element) => element.getAttribute('name') === endSectionName
        );
      }

      updateScope() {
        this.clearScopeItems();
        this.classList.remove('is-ready');
        this.style.setProperty('--campaign-gradient-height', '0px');

        const startSection = this.closest('.shopify-section');
        const endTarget = this.findEndTarget();
        const endSection = endTarget?.closest('.shopify-section');
        if (!startSection || !endSection) return;

        let currentSection = startSection.nextElementSibling;
        let reachedEnd = false;

        while (currentSection) {
          if (currentSection.classList.contains('shopify-section')) {
            this.scopeItems.push(currentSection);
            if (currentSection === endSection) {
              reachedEnd = true;
              break;
            }
          }
          currentSection = currentSection.nextElementSibling;
        }

        if (!reachedEnd) {
          this.clearScopeItems();
          return;
        }

        this.scopeItems.forEach((item) => item.classList.add('campaign-gradient-scope-item'));

        const startOffset = Number.parseFloat(this.dataset.startOffset || '0') || 0;
        const endOffset = Number.parseFloat(this.dataset.endOffset || '0') || 0;
        const startTop = this.getBoundingClientRect().top;
        const endBottom = endSection.getBoundingClientRect().bottom;
        const height = Math.max(0, Math.ceil(endBottom - startTop - startOffset + endOffset));

        this.style.setProperty('--campaign-gradient-height', `${height}px`);
        this.classList.toggle('is-ready', height > 0);
      }
    }

    customElements.define('campaign-gradient-background', CampaignGradientBackground);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('flash-sale-products')) return;

  // Timestamps are rendered by Shopify Liquid, matching campaign-countdown.
  // Do not parse merchant date strings in the visitor's browser timezone.
  const calculateCampaignStock = (initialValue, finalValue, timeline, enabled = true) => {
    const raw = String(finalValue ?? '').trim();
    const configured = enabled && raw !== '' && Number.isFinite(Number(raw));
    const finalRemaining = configured ? Math.max(0, Math.floor(Number(raw))) : 0;
    const initial = Number(initialValue);
    const total = Math.max(finalRemaining, Number.isFinite(initial) ? Math.floor(initial) : 0);
    let remaining = finalRemaining;
    const start = Number(timeline?.stockStartTs);
    const end = Number(timeline?.stockEndTs);
    // A configured zero always keeps the existing zero-stock appearance.
    if (configured && finalRemaining > 0 && start > 0 && end > start) {
      const now = Math.floor(Date.now() / 1000);
      const fraction = Math.max(0, Math.min(1, (now - start) / (end - start)));
      remaining = Math.max(finalRemaining, total - Math.floor((total - finalRemaining) * fraction));
    }
    const claimed = remaining === 0 ? 100 : total > 0 ? Math.max(0, Math.min(99, Math.round((total - remaining) / total * 100))) : 0;
    return { configured, remaining, claimed, soldOut: configured && remaining === 0 };
  };

  class FlashSaleProducts extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.addEventListener('click', (event) => this.onClick(event), { signal: this.controller.signal });
      this.querySelectorAll('[data-flash-card]').forEach((card) => this.updateCard(card));
      const refreshStock = () => {
        this.querySelectorAll('[data-campaign-stock]').forEach((card) => this.updateStock(card));
      };
      if (Number(this.dataset.stockEndTs) > Number(this.dataset.stockStartTs) && this.querySelector('[data-campaign-stock]')) {
        this.stockTimer = window.setInterval(refreshStock, 1000);
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) refreshStock();
        }, { signal: this.controller.signal });
      }
    }

    disconnectedCallback() {
      window.clearInterval(this.stockTimer);
      this.controller?.abort();
      this.controller = null;
    }

    updateStock(card) {
      const variant = card.querySelector('[data-flash-variant].is-active');
      if (!variant) return;
      const data = variant.dataset;
      const { configured, remaining, claimed, soldOut } = calculateCampaignStock(
        data.stockTotal, data.stockRemaining, this.dataset, card.hasAttribute('data-campaign-stock')
      );
      card.classList.toggle('is-campaign-sold-out', soldOut);
      card.querySelector('[data-flash-discount]').hidden = soldOut || !data.discountAmount;
      const stock = card.querySelector('[data-flash-stock]');
      stock.hidden = !configured;
      stock.querySelector('[data-stock-claimed]').textContent = claimed;
      stock.querySelector('[data-stock-left]').textContent = remaining;
      stock.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', String(claimed));
      stock.querySelector('[data-stock-fill]').style.width = claimed + '%';
      card.querySelector('[data-flash-sold-badge]').hidden = !soldOut;
      card.querySelector('[data-flash-sold-actions]').hidden = !soldOut;
      card.querySelector('[data-flash-actions]').hidden = soldOut;
      const button = card.querySelector('[data-flash-buy]');
      button.disabled = Boolean(this.checkoutPending) || soldOut || data.variantAvailable !== 'true' || card.dataset.cartPending === 'true';
    }

    updateCard(card) {
      const variant = card.querySelector('[data-flash-variant].is-active');
      if (!variant) return;
      const data = variant.dataset;
      this.updateStock(card);
      card.querySelector('[data-flash-price]').textContent = data.price;
      const compare = card.querySelector('[data-flash-compare]');
      compare.textContent = data.comparePrice;
      compare.hidden = !data.comparePrice;
      const badge = card.querySelector('[data-flash-discount]');
      badge.querySelector('[data-flash-discount-amount]').textContent = data.discountAmount;
      badge.querySelector('[data-flash-discount-percent]').textContent = data.discountPercent;
      card.querySelectorAll('[data-flash-link]').forEach((link) => {
        if (data.variantUrl) link.href = data.variantUrl;
      });
    }

    async onClick(event) {
      const variant = event.target.closest('[data-flash-variant]');
      if (variant) {
        const card = variant.closest('[data-flash-card]');
        card.querySelectorAll('[data-flash-variant]').forEach((button) => {
          const active = button === variant;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        this.updateCard(card);
        return;
      }
      const notify = event.target.closest('[data-flash-notify]');
      if (notify) {
        const card = notify.closest('[data-flash-card]');
        if (!card.classList.contains('is-campaign-sold-out')) return;
        notify.dispatchEvent(new CustomEvent('igarden:stock-notify-request', {
          bubbles: true,
          detail: { source: 'flash-sale-products', trigger: notify }
        }));
        return;
      }
      const button = event.target.closest('[data-flash-buy]');
      if (!button || button.disabled || this.checkoutPending) return;
      event.preventDefault();
      const card = button.closest('[data-flash-card]');
      const source = card.querySelector('[data-flash-variant].is-active');
      if (!source || card.dataset.cartPending === 'true' || card.classList.contains('is-campaign-sold-out') || source.dataset.variantAvailable !== 'true') return;
      const error = card.querySelector('[data-flash-error]');
      error.hidden = true;
      this.checkoutPending = true;
      card.dataset.cartPending = 'true';
      this.querySelectorAll('[data-flash-card]').forEach((item) => this.updateStock(item));
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      const originalText = button.textContent;
      button.textContent = this.dataset.loadingText;
      try {
        if (!window.iGardenCart) throw new Error('iGardenCart is unavailable.');
        await window.iGardenCart.buyNow([{ id: Number(source.dataset.variantId), quantity: 1 }], {
          activeElement: button,
          discountCode: source.dataset.productCode || '',
          replaceCart: true,
          render: false,
          source: 'flash-sale-products'
        });
      } catch {
        if (this.isConnected) { error.textContent = this.dataset.errorText; error.hidden = false; }
      } finally {
        this.checkoutPending = false;
        delete card.dataset.cartPending;
        button.removeAttribute('aria-busy');
        button.textContent = originalText;
        if (this.isConnected) this.querySelectorAll('[data-flash-card]').forEach((item) => this.updateCard(item));
      }
    }
  }

  customElements.define('flash-sale-products', FlashSaleProducts);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      updateUtilityBarHeight();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function updateUtilityBarHeight() {
    const utilityBar = document.querySelector('.utility-bar');
    document.documentElement.style.setProperty('--utility-bar-height', `${utilityBar && !window.pageYOffset ? utilityBar.offsetHeight : 0}px`);
  }

  // Ensure CSS variable exists even when sticky-header is disabled
  updateUtilityBarHeight();
  window.addEventListener('scroll', updateUtilityBarHeight);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  if (!customElements.get('search-results-page')) {
    customElements.define(
      'search-results-page',
      class SearchResultsPage extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          if (this.dataset.normalizeType === 'true') {
            const normalizedUrl = new URL(window.location.href);
            normalizedUrl.searchParams.set('type', 'product');
            normalizedUrl.searchParams.set('options[prefix]', 'last');
            normalizedUrl.searchParams.delete('page');
            window.location.replace(normalizedUrl.toString());
            return;
          }

          this.querySelectorAll('[data-search-results-back]').forEach((button) => {
            button.addEventListener('click', () => this.goBack());
          });

          const sortSelect = this.querySelector('[data-search-results-sort]');
          if (sortSelect?.hasAttribute('data-article-sort')) {
            this.initializeArticleSort(sortSelect);
          } else {
            sortSelect?.addEventListener('change', () => sortSelect.form?.requestSubmit());
          }

          this.loadInactiveCount();
        }

        goBack() {
          if (window.history.length > 1) {
            window.history.back();
            return;
          }

          window.location.assign(this.dataset.fallbackUrl || '/');
        }

        initializeArticleSort(select) {
          const allowedSorts = ['relevance', 'published-descending', 'published-ascending'];
          const pageUrl = new URL(window.location.href);
          const requestedSort = pageUrl.searchParams.get('article_sort') || 'relevance';
          const activeSort = allowedSorts.includes(requestedSort) ? requestedSort : 'relevance';
          select.value = activeSort;

          select.addEventListener('change', () => {
            const nextUrl = new URL(window.location.href);
            nextUrl.searchParams.delete('page');
            nextUrl.searchParams.delete('sort_by');

            if (select.value === 'relevance') {
              nextUrl.searchParams.delete('article_sort');
            } else {
              nextUrl.searchParams.set('article_sort', select.value);
            }

            window.location.assign(nextUrl.toString());
          });

          if (activeSort !== 'relevance') this.loadSortedArticles(activeSort, select);
        }

        async loadSortedArticles(sortMode, select) {
          const grid = this.querySelector('#SearchResultsGrid');
          if (!grid) return;

          grid.setAttribute('aria-busy', 'true');

          try {
            const reverse = sortMode === 'published-descending';
            const index = await this.getArticleIndex(reverse);
            const pageSize = 24;
            const requestedPage = Number.parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10);
            const totalPages = Math.max(1, Math.ceil(index.cursors.length / pageSize));
            const currentPage = Math.min(Math.max(requestedPage, 1), totalPages);

            if (currentPage !== requestedPage) {
              const correctedUrl = new URL(window.location.href);
              correctedUrl.searchParams.set('page', String(currentPage));
              window.location.replace(correctedUrl.toString());
              return;
            }

            const startIndex = (currentPage - 1) * pageSize;
            const after = startIndex > 0 ? index.cursors[startIndex - 1] : null;
            const first = Math.min(pageSize, index.cursors.length - startIndex);
            const articleVariables = {
              first,
              after,
              query: this.dataset.searchTerms || '',
              reverse
            };
            let articleData;

            try {
              articleData = await this.requestStorefront(this.articlePageQuery, articleVariables);
            } catch (error) {
              const isMetafieldAccessError = String(error?.message || error).includes('unauthenticated_read_metafields');
              if (!isMetafieldAccessError) throw error;
              articleData = await this.requestStorefront(this.articlePageFallbackQuery, articleVariables);
            }

            this.renderArticleCards(grid, articleData.articles.nodes);
            this.renderArticlePagination(totalPages, currentPage, sortMode);

            const articleCount = this.querySelector('[data-search-tab-count="article"]');
            if (articleCount) articleCount.textContent = String(index.cursors.length);
          } catch (error) {
            console.error('Failed to sort search articles', error);
            select.value = 'relevance';
          } finally {
            grid.removeAttribute('aria-busy');
          }
        }

        async getArticleIndex(reverse) {
          const terms = this.dataset.searchTerms || '';
          const cacheKey = `igarden.article-search-index.v1:${window.Shopify?.shop || window.location.host}:${terms}:${reverse}`;

          try {
            const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
            if (cached?.createdAt && Date.now() - cached.createdAt < 300000 && Array.isArray(cached.cursors)) {
              return cached;
            }
          } catch (error) {
          }

          const cursors = [];
          let after = null;
          let hasNextPage = true;
          let requestCount = 0;

          while (hasNextPage && requestCount < 40) {
            const data = await this.requestStorefront(this.articleIndexQuery, {
              first: 250,
              after,
              query: terms,
              reverse
            });
            const connection = data.articles;
            connection.edges.forEach((edge) => cursors.push(edge.cursor));
            hasNextPage = connection.pageInfo.hasNextPage;
            after = connection.pageInfo.endCursor;
            requestCount += 1;
          }

          if (hasNextPage) throw new Error('Article index limit exceeded');

          const index = { createdAt: Date.now(), cursors };
          try {
            sessionStorage.setItem(cacheKey, JSON.stringify(index));
          } catch (error) {
          }
          return index;
        }

        async requestStorefront(query, variables) {
          const apiUrl = this.dataset.storefrontApiUrl;
          if (!apiUrl) throw new Error('Storefront API URL is missing');

          const response = await fetch(apiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ query, variables })
          });

          if (!response.ok) throw new Error(String(response.status));
          const payload = await response.json();
          if (payload.errors?.length) throw new Error(payload.errors[0].message);
          return payload.data;
        }

        renderArticleCards(grid, articles) {
          const fragment = document.createDocumentFragment();
          const routeRoot = window.Shopify?.routes?.root || '/';
          const normalizedRoot = routeRoot.endsWith('/') ? routeRoot : `${routeRoot}/`;
          const language = document.documentElement.lang || 'en';
          const dateFormatter = new Intl.DateTimeFormat(language, {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          });

          articles.forEach((article, index) => {
            const articleUrl = `${normalizedRoot}blogs/${encodeURIComponent(article.blog.handle)}/${encodeURIComponent(article.handle)}`;
            const item = document.createElement('li');
            item.className = 'igarden-search-page__grid-item';

            const card = document.createElement('article');
            card.className = 'igarden-search-card igarden-search-card--article';

            const mediaLink = document.createElement('a');
            mediaLink.className = 'igarden-search-card__media-link';
            mediaLink.href = articleUrl;
            mediaLink.setAttribute('aria-label', article.title);

            if (article.image) {
              const image = document.createElement('img');
              image.className = 'igarden-search-card__media';
              image.src = article.image.url;
              image.alt = article.image.altText || article.title;
              image.loading = index < 4 ? 'eager' : 'lazy';
              if (article.image.width) image.width = article.image.width;
              if (article.image.height) image.height = article.image.height;
              mediaLink.append(image);
            }

            const firstTag = article.tags?.[0];
            if (firstTag) {
              const tag = document.createElement('span');
              tag.className = 'igarden-search-card__tag';
              tag.style.setProperty('--igarden-search-tag-background', article.tagColor?.value || '#6366f1');
              tag.textContent = firstTag;
              mediaLink.append(tag);
            }

            const content = document.createElement('div');
            content.className = 'igarden-search-card__content';

            const heading = document.createElement('h2');
            heading.className = 'igarden-search-card__title';
            const titleLink = document.createElement('a');
            titleLink.href = articleUrl;
            titleLink.textContent = article.title;
            heading.append(titleLink);

            const date = document.createElement('p');
            date.className = 'igarden-search-card__date';
            const time = document.createElement('time');
            time.dateTime = article.publishedAt;
            time.textContent = dateFormatter.format(new Date(article.publishedAt));
            date.append(time);

            content.append(heading, date);
            card.append(mediaLink, content);
            item.append(card);
            fragment.append(item);
          });

          grid.replaceChildren(fragment);
        }

        renderArticlePagination(totalPages, currentPage, sortMode) {
          const container = this.querySelector('[data-search-pagination]');
          if (!container) return;
          if (totalPages <= 1) {
            container.replaceChildren();
            return;
          }

          const wrapper = document.createElement('div');
          wrapper.className = 'pagination-wrapper';
          wrapper.dataset.page = String(currentPage);
          const nav = document.createElement('nav');
          nav.className = 'pagination';
          nav.setAttribute('role', 'navigation');
          nav.setAttribute('aria-label', this.dataset.paginationLabel || 'Pagination');
          const list = document.createElement('ul');
          list.className = 'pagination__list list-unstyled';
          list.setAttribute('role', 'list');

          if (currentPage > 1) {
            list.append(this.createPaginationItem(currentPage - 1, '‹', this.dataset.paginationPrevious, sortMode, true));
          }

          const pageNumbers = new Set([1, totalPages, currentPage - 1, currentPage, currentPage + 1]);
          const visiblePages = Array.from(pageNumbers)
            .filter((page) => page >= 1 && page <= totalPages)
            .sort((a, b) => a - b);

          visiblePages.forEach((page, index) => {
            if (index > 0 && page - visiblePages[index - 1] > 1) {
              const ellipsisItem = document.createElement('li');
              const ellipsis = document.createElement('span');
              ellipsis.className = 'pagination__item';
              ellipsis.textContent = '…';
              ellipsisItem.append(ellipsis);
              list.append(ellipsisItem);
            }

            list.append(this.createPaginationItem(page, String(page), null, sortMode, false, page === currentPage));
          });

          if (currentPage < totalPages) {
            list.append(this.createPaginationItem(currentPage + 1, '›', this.dataset.paginationNext, sortMode, true));
          }

          nav.append(list);
          wrapper.append(nav);
          container.replaceChildren(wrapper);
        }

        createPaginationItem(page, text, label, sortMode, isArrow, isCurrent = false) {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.className = `pagination__item${isArrow ? ' pagination__item-arrow link motion-reduce' : ' link'}`;
          link.textContent = text;

          if (isCurrent) {
            link.classList.add('pagination__item--current', 'light');
            link.setAttribute('role', 'link');
            link.setAttribute('aria-disabled', 'true');
            link.setAttribute('aria-current', 'page');
          } else {
            const pageUrl = new URL(window.location.href);
            pageUrl.searchParams.set('page', String(page));
            pageUrl.searchParams.set('article_sort', sortMode);
            pageUrl.searchParams.delete('sort_by');
            pageUrl.hash = 'SearchResultsGrid';
            link.href = pageUrl.toString();
          }

          const pageLabel = (this.dataset.paginationPage || 'Page __NUMBER__').replace('__NUMBER__', String(page));
          link.setAttribute('aria-label', label || pageLabel);
          item.append(link);
          return item;
        }

        get articleIndexQuery() {
          return `query ArticleIndex($first: Int!, $after: String, $query: String!, $reverse: Boolean!) {
            articles(first: $first, after: $after, query: $query, sortKey: PUBLISHED_AT, reverse: $reverse) {
              edges { cursor }
              pageInfo { hasNextPage endCursor }
            }
          }`;
        }

        get articlePageQuery() {
          return `query SearchArticlesPage($first: Int!, $after: String, $query: String!, $reverse: Boolean!) {
            articles(first: $first, after: $after, query: $query, sortKey: PUBLISHED_AT, reverse: $reverse) {
              nodes {
                id
                handle
                title
                publishedAt
                tags
                tagColor: metafield(namespace: "custom", key: "tag_color") { value }
                image { url(transform: { maxWidth: 720 }) altText width height }
                blog { handle }
              }
            }
          }`;
        }

        get articlePageFallbackQuery() {
          return `query SearchArticlesPageWithoutMetafields($first: Int!, $after: String, $query: String!, $reverse: Boolean!) {
            articles(first: $first, after: $after, query: $query, sortKey: PUBLISHED_AT, reverse: $reverse) {
              nodes {
                id
                handle
                title
                publishedAt
                tags
                image { url(transform: { maxWidth: 720 }) altText width height }
                blog { handle }
              }
            }
          }`;
        }

        loadInactiveCount() {
          const terms = this.dataset.searchTerms?.trim();
          const sectionId = this.dataset.searchCountSectionId;
          const activeType = this.dataset.activeType;
          if (!terms || !sectionId || !activeType) return;

          const inactiveType = activeType === 'article' ? 'product' : 'article';
          const target = this.querySelector(`[data-search-tab-count="${inactiveType}"]`);
          if (!target) return;

          const countUrl = new URL(this.dataset.searchUrl || '/search', window.location.origin);
          countUrl.searchParams.set('q', terms);
          countUrl.searchParams.set('type', inactiveType);
          countUrl.searchParams.set('options[prefix]', 'last');
          countUrl.searchParams.set('section_id', sectionId);

          fetch(countUrl.toString())
            .then((response) => {
              if (!response.ok) throw new Error(String(response.status));
              return response.text();
            })
            .then((markup) => {
              const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
              const countElement = documentFragment.querySelector('[data-header-search-count]');
              const count = Number.parseInt(countElement?.textContent || '', 10);
              if (Number.isFinite(count)) target.textContent = String(count);
            })
            .catch(() => {
              target.textContent = '—';
            });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pool-cleaner-quiz"] && !Shopify.designMode) return;
  try {
    
  const POOL_QUIZ_QUESTION_WEIGHTS = [1, 0.5, 0.5, 0.5, 2];
  const POOL_QUIZ_MIN_SCORE = 28;
  const POOL_QUIZ_MAX_OPTION_SCORE = 10;
  const POOL_QUIZ_REASON_SCORE_THRESHOLD = 8;

  if (!customElements.get('pool-cleaner-quiz')) {
    customElements.define(
      'pool-cleaner-quiz',
      class PoolCleanerQuiz extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;

          this.dataset.initialized = 'true';
          this.questions = Array.from(this.querySelectorAll('[data-pool-quiz-question]'));
          this.backButton = this.querySelector('[data-pool-quiz-back]');
          this.backWrap = this.querySelector('[data-pool-quiz-back-wrap]');
          this.formView = this.querySelector('[data-pool-quiz-form-view]');
          this.resultView = this.querySelector('[data-pool-quiz-results]');
          this.resultHeading = this.querySelector('[data-pool-quiz-result-heading]');
          this.resultSubheading = this.querySelector('[data-pool-quiz-result-subheading]');
          this.resultSubheadingTemplate = this.resultSubheading?.textContent.trim() || '';
          this.resultList = this.querySelector('[data-pool-quiz-result-list]');
          this.resultEmpty = this.querySelector('[data-pool-quiz-result-empty]');
          this.resultCards = new Map(
            Array.from(this.querySelectorAll('[data-pool-quiz-result-card]')).map((card) => [
              String(card.dataset.variantId),
              card
            ])
          );
          this.reselectButton = this.querySelector('[data-pool-quiz-reselect]');
          this.ratingButtons = Array.from(this.querySelectorAll('[data-pool-quiz-rating-value]'));
          this.ratingStatus = this.querySelector('[data-pool-quiz-rating-status]');
          this.answers = {};
          this.scoreData = this.readScoreData();
          this.currentIndex = 0;
          this.currentTopCandidates = [];
          this.ratingValue = 0;
          this.quizRunId = this.createQuizRunId();
          this.feedbackPending = false;
          this.advanceTimer = null;

          this.initializeDescriptionToggles();

          this.querySelectorAll('[data-pool-quiz-answer]').forEach((input) => {
            input.addEventListener('click', () => this.handleAnswer(input));
          });

          this.backButton?.addEventListener('click', () => {
            window.clearTimeout(this.advanceTimer);
            this.showQuestion(Math.max(0, this.currentIndex - 1), true);
          });

          this.reselectButton?.addEventListener('click', () => this.resetQuiz());

          this.ratingButtons.forEach((button) => {
            button.addEventListener('click', () => this.handleRating(button));
          });

          this.addEventListener('click', (event) => {
            const descriptionToggle = event.target.closest('[data-pool-quiz-description-toggle]');
            if (descriptionToggle) {
              this.handleDescriptionToggle(descriptionToggle);
              return;
            }

            const addButton = event.target.closest('[data-pool-quiz-add]');
            if (addButton) this.addVariantToCart(addButton);
          });

          this.addEventListener('shopify:block:select', (event) => {
            const question = event.target.closest('[data-pool-quiz-question]');
            if (!question) return;

            const index = this.questions.indexOf(question);
            if (index >= 0) {
              this.showFormView();
              this.showQuestion(index, false);
            }
          });
        }

        handleAnswer(input) {
          const question = input.closest('[data-pool-quiz-question]');
          const questionKey = question?.dataset.questionKey;
          if (!question || !questionKey) return;

          this.answers[questionKey] = input.value;
          window.clearTimeout(this.advanceTimer);

          this.advanceTimer = window.setTimeout(() => {
            if (this.currentIndex < this.questions.length - 1) {
              this.showQuestion(this.currentIndex + 1, true);
              return;
            }

            const topCandidates = this.rankCandidates(
              this.scoreData.candidateIds,
              this.scoreData.scoreTables
            );

            this.showResults(topCandidates);

            this.dispatchEvent(
              new CustomEvent('pool-quiz:complete', {
                bubbles: true,
                detail: {
                  sectionId: this.dataset.sectionId,
                  answers: { ...this.answers },
                  answerDetails: this.getAnswerDetails(),
                  questionWeights: [...POOL_QUIZ_QUESTION_WEIGHTS],
                  topCandidates
                }
              })
            );
          }, 220);
        }

        readScoreData() {
          const scoreDataElement = this.querySelector('[data-pool-quiz-score-data]');
          if (!scoreDataElement) return { candidateIds: [], scoreTables: {} };

          try {
            const scoreData = JSON.parse(scoreDataElement.textContent);
            return {
              candidateIds: Array.isArray(scoreData.candidateIds) ? scoreData.candidateIds : [],
              scoreTables: scoreData.scoreTables && typeof scoreData.scoreTables === 'object'
                ? scoreData.scoreTables
                : {}
            };
          } catch {
            return { candidateIds: [], scoreTables: {} };
          }
        }

        rankCandidates(candidateIds = [], scoreTables = {}) {
          const fallbackCandidateIds = Object.keys(scoreTables.q1 || {});
          const uniqueCandidateIds = [...new Set(
            (candidateIds.length > 0 ? candidateIds : fallbackCandidateIds).map(String)
          )];
          const selectedAnswers = this.questions.map((question) => {
            const questionKey = question.dataset.questionKey;
            const answerKey = this.answers[questionKey];
            const weightIndex = Number(questionKey.replace('q', '')) - 1;
            const weight = Number(POOL_QUIZ_QUESTION_WEIGHTS[weightIndex] ?? 1);
            const selectedInput = answerKey
              ? question.querySelector(`[data-pool-quiz-answer][value="${answerKey}"]`)
              : null;

            return {
              questionKey,
              answerKey,
              weight,
              reason: selectedInput?.dataset.recommendationReason?.trim() || ''
            };
          });
          const maximumScore = selectedAnswers.reduce(
            (total, answer) => total + answer.weight * POOL_QUIZ_MAX_OPTION_SCORE,
            0
          );

          return uniqueCandidateIds
            .map((variantId) => {
              let totalScore = 0;
              let hasCompleteScores = true;
              const reasons = [];

              selectedAnswers.forEach(({ questionKey, answerKey, weight, reason }) => {
                const rawScore = scoreTables[questionKey]?.[variantId]?.[answerKey];

                if (rawScore === undefined || rawScore === null || rawScore === '') {
                  hasCompleteScores = false;
                  return;
                }

                const score = Number(rawScore);
                if (!Number.isFinite(score) || !Number.isFinite(weight)) {
                  hasCompleteScores = false;
                  return;
                }

                totalScore += weight * score;
                if (score > POOL_QUIZ_REASON_SCORE_THRESHOLD && reason) {
                  reasons.push({ questionKey, answerKey, score, text: reason });
                }
              });

              if (!hasCompleteScores || !Number.isFinite(maximumScore) || maximumScore <= 0) return null;

              const matchPercentage = Math.max(
                0,
                Math.min(100, Math.round((totalScore / maximumScore) * 100))
              );

              return { variantId, score: totalScore, matchPercentage, reasons };
            })
            .filter((candidate) => candidate && candidate.score > POOL_QUIZ_MIN_SCORE)
            .sort((candidateA, candidateB) => {
              if (candidateB.score !== candidateA.score) return candidateB.score - candidateA.score;
              return candidateA.variantId.localeCompare(candidateB.variantId, undefined, { numeric: true });
            })
            .slice(0, 3);
        }

        showResults(topCandidates) {
          this.collapseDescriptionToggles();
          this.currentTopCandidates = topCandidates.map((candidate, index) => ({
            rank: index + 1,
            variantId: String(candidate.variantId),
            score: candidate.score,
            matchPercentage: candidate.matchPercentage,
            reasons: candidate.reasons.map((reason) => ({ ...reason }))
          }));

          this.resultCards.forEach((card) => {
            card.hidden = true;
            card.removeAttribute('data-result-rank');
            card.removeAttribute('data-result-score');
            card.removeAttribute('data-result-match');

            const match = card.querySelector('[data-pool-quiz-match]');
            const matchValue = match?.querySelector('[data-pool-quiz-match-value]');
            if (match) {
              if (matchValue) matchValue.textContent = '';
              match.hidden = true;
            }

            const reasonContainer = card.querySelector('[data-pool-quiz-reasons]');
            const reasonList = reasonContainer?.querySelector('[data-pool-quiz-reason-list]');
            if (reasonContainer) {
              reasonList?.replaceChildren();
              reasonContainer.hidden = true;
            }
          });

          let visibleResultCount = 0;
          this.currentTopCandidates.forEach((candidate) => {
            const card = this.resultCards.get(candidate.variantId);
            if (!card || !this.resultList) return;

            card.dataset.resultRank = String(candidate.rank);
            card.dataset.resultScore = String(candidate.score);
            card.dataset.resultMatch = String(candidate.matchPercentage);

            const match = card.querySelector('[data-pool-quiz-match]');
            const matchValue = match?.querySelector('[data-pool-quiz-match-value]');
            if (match) {
              if (matchValue) matchValue.textContent = `${candidate.matchPercentage}%`;
              match.hidden = false;
            }

            const reasonContainer = card.querySelector('[data-pool-quiz-reasons]');
            const reasonList = reasonContainer?.querySelector('[data-pool-quiz-reason-list]');
            if (reasonContainer && reasonList && candidate.reasons.length > 0) {
              candidate.reasons.forEach((reason) => {
                const item = document.createElement('li');
                item.textContent = reason.text;
                reasonList.append(item);
              });
              reasonContainer.hidden = false;
            }

            card.hidden = false;
            this.resultList.append(card);
            visibleResultCount += 1;
          });

          if (this.resultEmpty) this.resultEmpty.hidden = visibleResultCount > 0;
          if (this.resultSubheading) {
            this.resultSubheading.textContent = this.resultSubheadingTemplate.replace(
              /\[count\]/g,
              String(visibleResultCount)
            );
          }
          if (this.formView) this.formView.hidden = true;
          if (this.resultView) this.resultView.hidden = false;

          window.requestAnimationFrame(() => {
            this.resultHeading?.focus();
            this.scrollToSectionStart();
          });
        }

        showFormView() {
          if (this.resultView) this.resultView.hidden = true;
          if (this.formView) this.formView.hidden = false;
        }

        initializeDescriptionToggles() {
          this.querySelectorAll('[data-pool-quiz-description]').forEach((description) => {
            const content = description.querySelector('[data-pool-quiz-description-content]');
            const toggle = description.querySelector('[data-pool-quiz-description-toggle]');
            const items = Array.from(content?.querySelectorAll('.metafield-rich_text_field li') || []);
            if (!toggle || items.length <= 6) return;

            items.slice(6).forEach((item) => {
              item.dataset.poolQuizExtraItem = '';
            });
            toggle.hidden = false;
          });

          this.collapseDescriptionToggles();
        }

        collapseDescriptionToggles() {
          this.querySelectorAll('[data-pool-quiz-description-toggle]:not([hidden])').forEach((toggle) => {
            const description = toggle.closest('[data-pool-quiz-description]');
            if (description) description.dataset.collapsed = 'true';
            toggle.setAttribute('aria-expanded', 'false');
            toggle.textContent = toggle.dataset.viewMoreLabel || 'View more';
          });
        }

        handleDescriptionToggle(toggle) {
          const description = toggle.closest('[data-pool-quiz-description]');
          if (!description) return;

          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
          description.dataset.collapsed = isExpanded ? 'true' : 'false';
          toggle.setAttribute('aria-expanded', String(!isExpanded));
          toggle.textContent = isExpanded
            ? toggle.dataset.viewMoreLabel || 'View more'
            : toggle.dataset.viewLessLabel || 'View less';
        }

        resetQuiz() {
          window.clearTimeout(this.advanceTimer);
          this.answers = {};
          this.currentTopCandidates = [];
          this.ratingValue = 0;
          this.quizRunId = this.createQuizRunId();
          this.feedbackPending = false;
          this.querySelectorAll('[data-pool-quiz-answer]').forEach((input) => {
            input.checked = false;
          });
          this.resultCards.forEach((card) => {
            card.hidden = true;
          });
          this.ratingButtons.forEach((button) => {
            button.classList.remove('is-active');
            button.setAttribute('aria-pressed', 'false');
          });
          if (this.ratingStatus) this.ratingStatus.hidden = true;
          if (this.resultEmpty) this.resultEmpty.hidden = true;
          this.showFormView();
          this.showQuestion(0, true);
          this.scrollToSectionStart();
        }

        getAnswerDetails() {
          return this.questions.map((question) => {
            const questionKey = question.dataset.questionKey;
            const answerKey = this.answers[questionKey] || '';
            const selectedInput = answerKey
              ? question.querySelector(`[data-pool-quiz-answer][value="${answerKey}"]`)
              : null;
            const selectedCard = selectedInput?.nextElementSibling;

            return {
              questionKey,
              answerKey,
              question: question.querySelector('.pool-quiz__question-title')?.textContent.trim() || '',
              answer: selectedCard?.querySelector('.pool-quiz__card-title')?.textContent.trim() || ''
            };
          });
        }

        createQuizRunId() {
          if (typeof window.crypto?.randomUUID === 'function') return window.crypto.randomUUID();

          const randomValues = new Uint32Array(4);
          window.crypto?.getRandomValues?.(randomValues);
          const randomPart = Array.from(randomValues, (value) => value.toString(36)).join('');
          return `${Date.now().toString(36)}-${randomPart || Math.random().toString(36).slice(2)}`;
        }

        setRatingStatus(message) {
          if (!this.ratingStatus) return;
          this.ratingStatus.textContent = message;
          this.ratingStatus.hidden = false;
        }

        async handleRating(button) {
          if (this.feedbackPending) return;

          const rating = Number(button.dataset.poolQuizRatingValue);
          if (!Number.isInteger(rating) || rating < 1 || rating > 5) return;

          this.ratingValue = rating;
          this.ratingButtons.forEach((ratingButton) => {
            const value = Number(ratingButton.dataset.poolQuizRatingValue);
            ratingButton.classList.toggle('is-active', value <= rating);
            ratingButton.setAttribute('aria-pressed', value === rating ? 'true' : 'false');
          });

          const payload = {
            quizRunId: this.quizRunId,
            schemaVersion: 1,
            sectionId: this.dataset.sectionId,
            rating,
            answers: this.getAnswerDetails(),
            recommendations: this.currentTopCandidates.map((candidate) => ({ ...candidate })),
            market: this.dataset.market || '',
            locale: this.dataset.locale || '',
            pageUrl: window.location.href,
            submittedAt: new Date().toISOString()
          };

          this.dispatchEvent(
            new CustomEvent('pool-quiz:feedback', {
              bubbles: true,
              detail: payload
            })
          );

          if (this.dataset.feedbackEnabled !== 'true') {
            this.setRatingStatus(this.dataset.feedbackSuccess || 'Thank you for your feedback.');
            return;
          }

          if (typeof window.iGardenPoolQuizFeedback !== 'function') {
            this.setRatingStatus(this.dataset.feedbackError || 'Unable to submit feedback. Please try again.');
            return;
          }

          this.feedbackPending = true;
          this.ratingButtons.forEach((ratingButton) => {
            ratingButton.disabled = true;
          });
          this.setRatingStatus(this.dataset.feedbackSubmitting || 'Submitting...');

          try {
            await window.iGardenPoolQuizFeedback(payload);
            this.setRatingStatus(this.dataset.feedbackSuccess || 'Thank you for your feedback.');
          } catch (error) {
            this.setRatingStatus(this.dataset.feedbackError || 'Unable to submit feedback. Please try again.');
            console.error('Pool quiz feedback failed', error);
          } finally {
            this.feedbackPending = false;
            this.ratingButtons.forEach((ratingButton) => {
              ratingButton.disabled = false;
            });
          }
        }

        async addVariantToCart(button) {
          if (button.disabled || button.classList.contains('is-loading')) return;

          const variantId = String(button.dataset.variantId || '').trim();
          const discountCode = String(button.dataset.discountCode || '').trim();
          if (!variantId) return;

          const card = button.closest('[data-pool-quiz-result-card]');
          const status = card?.querySelector('[data-pool-quiz-add-status]');
          button.disabled = true;
          button.classList.add('is-loading');
          if (status) status.hidden = true;

          try {
            if (!window.iGardenCart) throw new Error('Cart service is unavailable.');
            await window.iGardenCart.addItem(
              { id: variantId, quantity: 1 },
              {
                activeElement: button,
                discountCode,
                redirectToCart: false,
                source: 'pool-cleaner-quiz'
              }
            );
          } catch (error) {
            if (status) {
              status.textContent = error.message;
              status.hidden = false;
            }
            console.error(error);
          } finally {
            button.disabled = false;
            button.classList.remove('is-loading');
          }
        }

        scrollToSectionStart() {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }

        showQuestion(index, moveFocus) {
          if (!this.questions[index]) return;

          this.currentIndex = index;
          this.questions.forEach((question, questionIndex) => {
            const isActive = questionIndex === index;
            question.hidden = !isActive;
            question.classList.toggle('is-active', isActive);
            question.classList.remove('is-entering');
          });

          const activeQuestion = this.questions[index];
          activeQuestion.classList.add('is-entering');
          activeQuestion.addEventListener(
            'animationend',
            () => activeQuestion.classList.remove('is-entering'),
            { once: true }
          );

          if (this.backButton) this.backButton.hidden = index === 0;
          if (this.backWrap) this.backWrap.hidden = index === 0;
          if (moveFocus) activeQuestion.querySelector('.pool-quiz__question-title')?.focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pool-opening-swim-scenes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pool-opening-swim-scenes')) {
    customElements.define('pool-opening-swim-scenes', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.cards = [...this.querySelectorAll('[data-scene-card]')];
        this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.activeCard = null;
        this.requestId = 0;
        this.lastDrag = 0;
        this.userPaused = false;
        this.sectionVisible = false;
        const options = { signal: this.controller.signal };

        this.cards.forEach((card) => {
          const media = card.querySelector('[data-scene-media]');
          media.addEventListener('pointerenter', () => {
            if (this.hoverQuery.matches) this.play(card);
          }, options);
          media.addEventListener('pointerleave', () => {
            if (this.shouldAutoplay()) return;
            if (this.hoverQuery.matches && !media.contains(document.activeElement)) this.stop(card);
          }, options);
          media.addEventListener('focusout', (event) => {
            if (this.shouldAutoplay()) return;
            if (!media.contains(event.relatedTarget) && !media.matches(':hover')) this.stop(card);
          }, options);
          media.addEventListener('pointerdown', (event) => {
            this.pointerStart = { x: event.clientX, y: event.clientY };
          }, options);
          media.addEventListener('pointermove', (event) => {
            if (this.pointerStart && Math.hypot(event.clientX - this.pointerStart.x, event.clientY - this.pointerStart.y) > 8) this.lastDrag = Date.now();
          }, options);
        });
        document.addEventListener('pointerup', () => { this.pointerStart = null; }, options);
        document.addEventListener('pointercancel', () => { this.pointerStart = null; }, options);
        this.addEventListener('click', (event) => {
          if (this.hoverQuery.matches) return;
          const media = event.target.closest('[data-scene-media]');
          if (!media || !this.contains(media)) return;
          if (event.detail !== 0 && Date.now() - this.lastDrag < 400) return;
          const card = media.closest('[data-scene-card]');
          if (!card.querySelector('video, [data-scene-video]')) return;
          if (this.activeCard === card) {
            this.userPaused = true;
            this.stop(card);
          } else {
            this.userPaused = false;
            this.play(card, true);
          }
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stop();
          else if (this.shouldAutoplay() && this.sectionVisible && !this.activeCard) this.playNext();
        }, options);
        document.addEventListener('pool-opening-swim-scenes-play', (event) => {
          if (event.detail?.source !== this) this.stop();
        }, options);
        document.addEventListener('shopify:block:select', (event) => {
          const selected = this.cards.find((card) => card.dataset.blockId === event.detail.blockId);
          if (!selected || !this.contains(selected)) return;
          this.userPaused = true;
          this.stop();
          this.querySelector('[data-scenes-track]').scrollLeft = selected.offsetLeft - this.cards[0].offsetLeft;
        }, options);
        document.addEventListener('shopify:block:deselect', (event) => {
          if (!this.cards.some((card) => card.dataset.blockId === event.detail?.blockId)) return;
          this.userPaused = false;
          if (this.shouldAutoplay() && this.sectionVisible && !document.hidden) this.playNext();
        }, options);

        if ('IntersectionObserver' in window) {
          this.prepareObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.prepare(entry.target);
                this.prepareObserver.unobserve(entry.target);
              }
            });
          }, { rootMargin: '200px' });
          this.visibilityObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting && this.activeCard === entry.target && !this.shouldAutoplay()) this.stop(entry.target);
            });
          });
          this.cards.forEach((card) => {
            this.prepareObserver.observe(card);
            this.visibilityObserver.observe(card);
          });
        }

        this.sectionObserver = new IntersectionObserver((entries) => {
          this.sectionVisible = entries.some((entry) => entry.isIntersecting);
          if (!this.sectionVisible) {
            this.stop();
            return;
          }
          if (this.shouldAutoplay() && !document.hidden && !this.activeCard) this.playNext();
        }, { threshold: 0.35 });
        this.sectionObserver.observe(this);
      }

      shouldAutoplay() {
        return this.dataset.autoplay === 'true' && !this.reducedMotion.matches && !this.userPaused;
      }

      playableCards() {
        return this.cards.filter((card) => card.querySelector('video, [data-scene-video]'));
      }

      nextCard(from) {
        const cards = this.playableCards();
        if (!cards.length) return null;
        const index = from ? cards.indexOf(from) : -1;
        return cards[(index + 1) % cards.length];
      }

      playNext(from = null) {
        const next = this.nextCard(from);
        if (next) this.play(next);
      }

      advanceFrom(card) {
        if (!this.shouldAutoplay() || !this.sectionVisible || document.hidden) {
          this.stop(card);
          return;
        }
        const next = this.nextCard(card);
        if (!next) {
          this.stop(card);
          return;
        }
        if (next === card) {
          const video = card.querySelector('video');
          if (!video) return;
          try { video.currentTime = 0; } catch (error) { /* Metadata may not be ready. */ }
          video.play().catch(() => this.fail(card));
          return;
        }
        this.play(next);
      }

      scrollCardIntoView(card) {
        const track = this.querySelector('[data-scenes-track]');
        if (!track || track.scrollWidth <= track.clientWidth + 1) return;
        const left = card.offsetLeft - (this.cards[0]?.offsetLeft || 0);
        if (Math.abs(track.scrollLeft - left) < 2) return;
        track.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }

      prepare(card) {
        let video = card.querySelector('video');
        if (video) return video;
        const template = card.querySelector('[data-scene-video]');
        if (!template) return null;
        video = template.content.firstElementChild.cloneNode(true);
        video.preload = 'metadata';
        video.muted = true;
        const options = { signal: this.controller.signal };
        video.addEventListener('playing', () => {
          if (this.activeCard !== card) { video.pause(); return; }
          this.autoplayFailures = 0;
          card.classList.add('is-playing');
          card.querySelector('[data-scene-status]').textContent = '';
        }, options);
        video.addEventListener('ended', () => {
          if (this.activeCard === card) this.advanceFrom(card);
        }, options);
        video.addEventListener('error', () => {
          if (this.activeCard !== card) return;
          const next = this.nextCard(card);
          this.autoplayFailures = (this.autoplayFailures || 0) + 1;
          if (this.shouldAutoplay() && next && next !== card && this.autoplayFailures < this.playableCards().length) {
            this.play(next);
            return;
          }
          this.fail(card);
        }, options);
        template.after(video);
        return video;
      }

      async play(card, userAction = false) {
        if (this.activeCard === card && !userAction) return;
        const video = this.prepare(card);
        if (!video) return;
        if (this.activeCard !== card) {
          this.stop();
          document.dispatchEvent(new CustomEvent('pool-opening-swim-scenes-play', { detail: { source: this } }));
          this.activeCard = card;
        }
        const request = ++this.requestId;
        card.querySelector('[data-scene-status]').textContent = '';
        if (this.shouldAutoplay()) this.scrollCardIntoView(card);
        video.muted = true;
        try {
          await video.play();
        } catch (error) {
          if (request !== this.requestId || this.activeCard !== card) return;
          const next = this.nextCard(card);
          this.autoplayFailures = (this.autoplayFailures || 0) + 1;
          if (this.shouldAutoplay() && next && next !== card && this.autoplayFailures < this.playableCards().length) {
            this.play(next);
            return;
          }
          this.fail(card);
        }
      }

      stop(card = this.activeCard) {
        if (!card) return;
        if (this.activeCard === card) {
          this.activeCard = null;
          this.requestId++;
        }
        const video = card.querySelector('video');
        if (video) {
          video.pause();
          video.muted = true;
          try { video.currentTime = 0; } catch (error) { /* Metadata may not be ready. */ }
        }
        card.classList.remove('is-playing');
        card.querySelector('[data-scene-status]').textContent = '';
      }

      fail(card) {
        this.stop(card);
        card.querySelector('[data-scene-status]').textContent = 'Unable to play this video. Please try again.';
      }

      disconnectedCallback() {
        this.stop();
        this.controller?.abort();
        this.prepareObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.sectionObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
